import { environment } from 'src/environments/environment'

export const OPERATIONS_S3_ENDPOINT = `${environment.operationsApi}/api/v1`
